import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConfiguration } from '../api-configuration';
import { BaseService } from '../base-service';
import {
  AvailableAttendanceSchedule,
  MultiAttendancePayload,
} from '../models/subscription-attendance-manual.models';

@Injectable({ providedIn: 'root' })
export class SubscriptionAttendanceManualService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  multiAttendance(
    subscriptionId: number,
    detailId: number,
    payload: MultiAttendancePayload
  ): Observable<unknown> {
    return this.http.post(
      `${this.rootUrl}/api/v1/subscriptions/${subscriptionId}/details/${detailId}/multi-attendance`,
      payload,
      { headers: { 'X-Skip-Global-Error': 'true' } }
    );
  }

  getMultiAttendanceRecords(subscriptionId: number, detailId: number): Observable<unknown> {
    return this.http.get(
      `${this.rootUrl}/api/v1/subscriptions/${subscriptionId}/details/${detailId}/multi-attendance`,
      {
        params: { per_page: '100' },
        headers: { 'X-Skip-Global-Error': 'true' },
      }
    );
  }

  getAvailableSchedules(
    activityId: number,
    attendanceDate: string,
    subscriptionDetailId?: number | null
  ): Observable<{ success: boolean; data: AvailableAttendanceSchedule[] }> {
    const params: Record<string, string> = {
      activity_id: String(activityId),
      attendance_date: attendanceDate,
    };
    if (subscriptionDetailId) {
      params['subscription_detail_id'] = String(subscriptionDetailId);
    }

    return this.http.get<{ success: boolean; data: AvailableAttendanceSchedule[] }>(
      `${this.rootUrl}/api/v1/attendance/available-schedules`,
      {
        params,
        headers: { 'X-Skip-Global-Error': 'true' },
      }
    );
  }
}
